import { render, staticRenderFns } from "./sales-add.vue?vue&type=template&id=6689b4c6&scoped=true&"
import script from "./sales-add.vue?vue&type=script&lang=js&"
export * from "./sales-add.vue?vue&type=script&lang=js&"
import style0 from "./sales-add.vue?vue&type=style&index=0&id=6689b4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689b4c6",
  null
  
)

export default component.exports